// extracted by mini-css-extract-plugin
export default {"page":"SuSXuJ1p","mainWrapper":"SYb6ZJ0P","title":"cXmJQU0D","flexWrapper":"aDrOyDf3","backToGameButton":"QkWwvPAe","img":"A1rTrcK5"};
    if(module.hot) {
      // 1738090061531
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  